import React, { useState } from "react";
import { useParams } from "react-router-dom";
import countries from "./constant/countries";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CountryPage = () => {
  const { countryName } = useParams();
  const country = countries.find((c) => c.name === countryName);

  const [formData, setFormData] = useState({
    full_name: "",
    nationality: "",
    profession: "",
    email: "",
    phone_number: "",
    city: "",
    country: "",
    country_of_real_estate: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success("Form submitted successfully!");
  };

  if (!country) {
    return <div className="text-center mt-20 text-xl">Country not found</div>;
  }

  const { flag } = country;

  return (
    <>
      <section
        className="relative text-white min-h-[80vh] flex items-center justify-center overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg, rgba(184,239,67,1) 45%, rgba(139,176,60,1) 100%)",
        }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1616692474781-9ef0114c15b1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
          }}
        ></div>

        <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight font-[Aeonik]">
            Welcome to {countryName}
            <br />
            <span className="text-black"> Tariff-Real Estate Portal</span>
          </h1>
        </div>
      </section>

      <section className="min-h-screen py-16 px-4 sm:px-10 bg-gradient-to-b from-white to-gray-100 text-gray-800">
        <div className="max-w-4xl mx-auto">
          {flag && (
            <div className="p-4 bg-white rounded-xl shadow-md border w-full flex justify-center mb-10">
              <img
                src={flag}
                alt={countryName}
                className="w-32 sm:w-40 md:w-52 h-auto rounded-lg shadow"
              />
            </div>
          )}

          <p className="text-center mb-10 text-gray-600 max-w-2xl mx-auto">
            Please fill in the required fields to submit your interest in the
            {country.name} portal.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                placeholder="Full Name"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                placeholder="Nationality"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="text"
                name="profession"
                value={formData.profession}
                onChange={handleChange}
                placeholder="Profession"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="tel"
                name="phone_number"
                value={formData.phone_number}
                onChange={handleChange}
                placeholder="Phone Number"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="City of Residence"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleChange}
                placeholder="Country of Tariff"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
              <input
                type="text"
                name="country_of_real_estate"
                value={formData.country_of_real_estate}
                onChange={handleChange}
                placeholder="Country of Real Estate"
                className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
                required
              />
            </div>

            <textarea
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              placeholder="Write any comments or additional information"
              rows="4"
              className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 transition-shadow shadow-md hover:shadow-lg"
            ></textarea>

            <div className="text-center pt-4">
              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 transition-all duration-200 text-white font-semibold px-8 py-3 rounded-xl shadow-lg"
              >
                Submit Form
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default CountryPage;
